import { useFlags } from "launchdarkly-react-client-sdk";

import { FAX_FAILURE_DETAIL_FEATURE } from "constants/feature-flags";

/**
 * Whether the fax failure detail (reason, category, guidance) is turned on.
 *
 * Every surface that shows a fax reads the flag through this hook rather than reaching for the key
 * itself. Four files need the same answer — the three lists that build a RestQL query and the
 * status cell that renders the result — and a list that asks for the fields while the cell hides
 * them (or the reverse) is the failure mode this exists to prevent.
 */
export default function useFaxFailureDetailEnabled(): boolean {
  const flags = useFlags();

  return Boolean(flags[FAX_FAILURE_DETAIL_FEATURE]);
}
